import { PracticeFormAnswer } from "@physiofit-digital/physiofit_types";
import { BodyAreaSelection } from "./FormAnswerComponents/BodyAreaSelection";
import { ContractAnswer } from "./FormAnswerComponents/ContractAnswer";
import { CostBearerAnswer } from "./FormAnswerComponents/CostBearerAnswer";
import { DocumentUploadAnswer } from "./FormAnswerComponents/DocumentUploadAnswer";
import { MultipleChoiceAnswer } from "./FormAnswerComponents/MultipleChoiceAnswer";
import { OwnTextAnswer } from "./FormAnswerComponents/OwnTextAnswer";
import { PersonalInfoAnswer } from "./FormAnswerComponents/PersonalInfoAnswer";
import { ScaleAnswer } from "./FormAnswerComponents/ScaleAnswer";

type Props = {
  questionId: string;
  answer: PracticeFormAnswer;
  level?: number;
};

export const FormAnswer = ({ answer, questionId, level }: Props) => {
  const initialLevel = level || 0;
  const answerType = answer?.type;

  if (
    answerType === "multipleChoice" ||
    answerType === "singleChoice" ||
    answerType === "yesNo"
  ) {
    if (!answer.possibleFields) {
      console.error("MultipleChoiceAnswer requires possibleFields");
      return null;
    }
    return (
      <MultipleChoiceAnswer
        questionId={questionId}
        options={answer.options}
        possibleFields={answer.possibleFields}
        answerId={answer.answerId}
        level={initialLevel}
        isMultipleSelection={answerType === "multipleChoice"}
      />
    );
  }

  if (answerType === "OwnTextAnswer") {
    return <OwnTextAnswer questionId={questionId} answerId={answer.answerId} />;
  }

  if (answerType === "bodyArea") {
    return (
      <BodyAreaSelection questionId={questionId} answerId={answer.answerId} />
    );
  }

  if (answerType === "scale") {
    // Placeholder for ScaleAnswer component
    return (
      <ScaleAnswer
        questionId={questionId}
        answerId={answer.answerId}
        scaleData={answer.scaleData}
      />
    );
  }

  if (answerType === "documentUpload" || answerType === "recipeUpload") {
    return (
      <DocumentUploadAnswer
        questionId={questionId}
        answerId={answer.answerId}
      />
    );
  }

  if (answerType === "contract") {
    return (
      <ContractAnswer
        questionId={questionId}
        answerId={answer.answerId}
        contractToSign={answer.contractToSign}
      />
    );
  }

  if (answerType === "conditionAcceptance") {
    return <></>;
  }

  if (answerType === "personalInfo") {
    return (
      <PersonalInfoAnswer
        answerId={answer.answerId}
        questionId={questionId}
        noAddress={answer.options?.includes("noAddress")}
      />
    );
  }
  if (answerType === "costBearer") {
    return <CostBearerAnswer />;
  }

  return <div>Form {answerType} Component</div>;
};
